import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectHeroImage from "../ProjectHeroImage";
import Image from "../../../../img/redactd.png";
import Links from "../../../Links";

const Section = styled(ProjectSection)`
  background: #59009b;
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto auto auto auto;
  }
`;

const LocalProjectDescription = styled.p`
  margin-bottom: var(--spacing-medium);
  font-size: var(--font-size-text-small);

  @media (min-width: 768px) {
    padding: var(--spacing-clear) var(--spacing-medium);
  }
`;

function Redactd() {
  return (
    <Section>
      <ProjectTitle title="Redactd" tag="2026" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="React">
          <Icons type="react-small" />
        </Badge>
        <Badge small title="Agents & AI">
          <Icons type="ai-small" />
        </Badge>
        <Badge tooltip="large" small title="Web Components">
          <Icons type="web-components-small" />
        </Badge>
      </ProjectSectionSkills>

      <LocalProjectDescription>
        Build and compose real web layouts directly with Web Components. Move from prompt to production-ready layouts
        in-browser for any web framework.
      </LocalProjectDescription>

      <LocalProjectDescription>
        Design by hand on a pixel-perfect canvas or generate layouts via prompts, then switch modes freely: prompt,
        then craft; craft, then prompt. Import Web Components via CDN, compose through direct manipulation, and export
        as HTML or JSON.
      </LocalProjectDescription>

      <LocalProjectDescription>
        There is no separation between design and code. Embed components, define recipes, and use structured guidance
        grounded in professional UX guidelines.
      </LocalProjectDescription>

      <ButtonGroup>
        <Button href="https://redactd.xyz/" color="white" target="_blank" rel="noopener noreferrer">
          Build Now
        </Button>
        <Button
          href="https://www.designsystemscollective.com/pair-programming-with-ai-61b0021d6bec?source=friends_link&sk=8c5ccadaea0c8a7a14d29058fd3d8f36"
          color="white"
          target="_blank"
          rel="noopener noreferrer"
        >
          Read Blog
        </Button>
      </ButtonGroup>

      <ProjectHeroImage src={Image} desktop />
    </Section>
  );
}

export default Redactd;
